import { ResetPasswordConfirmPage } from "@cavort/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	token: z.string().catch(""),
});

export const Route = createFileRoute("/_auth/reset-password")({
	validateSearch: searchSchema,
	component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
	const { token } = Route.useSearch();
	const navigate = useNavigate();
	return <ResetPasswordConfirmPage token={token} onLoginClick={() => navigate({ to: "/login" })} />;
}
